import { render, staticRenderFns } from "./HiboImg.vue?vue&type=template&id=553f4208&scoped=true&"
import script from "./HiboImg.vue?vue&type=script&lang=ts&"
export * from "./HiboImg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553f4208",
  null
  
)

export default component.exports